/**
 * The player's phase once our answer is sent.
 *
 * Chrome fires `ontrack` INSIDE `setRemoteDescription(offer)` when the camera's offer
 * already declares its video track — before the answer exists. Setting `ice` after the
 * answer unconditionally overwrote `playing` and hid a live picture behind
 * "connecting…" for good (first real camera, 2026-09-30). A picture that arrived stays.
 */
export function phaseAfterAnswer<P extends string>(phase: P | 'playing'): P | 'playing' | 'ice' {
  return phase === 'playing' ? 'playing' : 'ice';
}
